import { sendToApi } from 'api/client'

export type BucketKey = 'post' | 'story' | 'carousel' | 'video_post' | 'email' | 'blog' | 'short_form_video'

export type PlanTier = 'starter' | 'growth' | 'enterprise' | null

export interface ContentDiscoveryMixEntry {
  key: BucketKey
  label: string
  count: number
  tryable: boolean
  starter_locked: boolean
  blurb: string | null
}

export interface ContentDiscoveryCurrentWeekCta {
  bucket_key: BucketKey
  label: string
  blurb: string
}

export interface ContentDiscoveryResponse {
  content_mix_bar_visible: boolean
  inline_cta_eligible: boolean
  plan_tier: PlanTier
  is_first_campaign: boolean
  integration_count: number
  tried_buckets_count: number
  mix: ContentDiscoveryMixEntry[]
  current_week_cta: ContentDiscoveryCurrentWeekCta | null
}

export const ContentDiscoveryClient = {
  get: (workspaceId: number) => {
    return sendToApi<ContentDiscoveryResponse>(`/w/${workspaceId}/content_discovery`, { method: 'GET' })
  },
}
